module.exports = {};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/hidden-keys.js